import React from 'react';

// ═══ Mini visual components (simplified interface illustrations) ═══

function VisualHub() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      {['Préparation pharmacies', 'Réception transporteurs', 'Réception produits'].map((m, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', padding: '8px 10px', background: 'white', borderRadius: 6, marginBottom: 3, borderLeft: '3px solid #7C3AED' }}>
          <span style={{ flex: 1, fontWeight: 600, fontSize: 11 }}>{m}</span>
          {i === 0 && <span style={{ background: '#7C3AED', color: 'white', borderRadius: 10, padding: '1px 8px', fontSize: 10, fontWeight: 700 }}>59</span>}
        </div>
      ))}
    </div>
  );
}

function VisualTournees() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ background: '#EEF6FF', borderRadius: 8, border: '1.5px solid #B3D4F0', padding: '6px 10px', marginBottom: 6 }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: '#1A5276' }}>🔧 Ma préparation (1)</div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '5px 8px', background: 'white', borderRadius: 6, marginTop: 4 }}>
          <span style={{ flex: 1, fontWeight: 600, fontSize: 10 }}>PHARMACIE DU CENTRE</span>
          <span style={{ fontSize: 9, padding: '2px 6px', borderRadius: 4, background: '#D4680A', color: 'white', fontWeight: 700 }}>En prépa</span>
        </div>
      </div>
      <div style={{ fontSize: 10, fontWeight: 700, color: '#1A5276', marginBottom: 4, display: 'flex', alignItems: 'center', gap: 4 }}>
        <span style={{ width: 16, height: 16, borderRadius: '50%', background: '#1A5276', color: 'white', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, fontWeight: 700 }}>1</span>
        Tournée 1 — 24  <span style={{ fontSize: 9, color: '#888', fontWeight: 400 }}>5 à faire</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', padding: '6px 8px', background: 'white', borderRadius: 6, marginBottom: 2, borderLeft: '2px solid #1A5276' }}>
        <span style={{ flex: 1, fontWeight: 500, fontSize: 10 }}>PHARMACIE DE LA GARE</span>
        <span style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #1A5276', color: '#1A5276', fontSize: 9, fontWeight: 700 }}>▶ Je prends</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', padding: '6px 8px', background: '#EEFAF0', borderRadius: 6, borderLeft: '2px solid #16A34A' }}>
        <span style={{ flex: 1, fontWeight: 500, fontSize: 10 }}>PHARMACIE BLANQUI</span>
        <span style={{ fontSize: 9, color: '#16A34A', fontWeight: 600 }}>Prête</span>
      </div>
    </div>
  );
}

function VisualClaim() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '8px 10px', background: 'white', borderRadius: 8, borderLeft: '3px solid #1A5276' }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 11 }}>PHARMACIE DE LA GARE</div>
          <div style={{ fontSize: 9, color: '#888' }}>S131044 20/03 17:24</div>
          <div style={{ marginTop: 3 }}><span style={{ fontSize: 8, padding: '2px 6px', borderRadius: 4, background: '#EEF6FF', color: '#1A5276', fontWeight: 700, border: '1px solid #B3D4F0' }}>📅 Départ Lun 23</span></div>
        </div>
        <span style={{ padding: '6px 10px', borderRadius: 8, border: '1.5px solid #1A5276', color: '#1A5276', fontSize: 10, fontWeight: 700 }}>▶ Je prends</span>
      </div>
    </div>
  );
}

function VisualQuickPanel() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ background: 'white', borderRadius: 12, padding: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <div><div style={{ fontWeight: 700, fontSize: 11 }}>PHARMACIE DE LA GARE</div><div style={{ fontSize: 8, color: '#888' }}>23 rue de la paix · T1</div></div>
          <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ textAlign: 'center' }}><div style={{ fontSize: 14, fontWeight: 800, color: '#1A5276' }}>7</div><div style={{ fontSize: 7, color: '#888' }}>produits</div></div>
            <div style={{ textAlign: 'center' }}><div style={{ fontSize: 14, fontWeight: 800, color: '#D4680A' }}>23</div><div style={{ fontSize: 7, color: '#888' }}>boîtes</div></div>
          </div>
        </div>
        <div style={{ padding: '6px 8px', borderRadius: 6, border: '1.5px dashed #1A5276', background: '#EEF6FF', display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
          <span>📸</span><span style={{ flex: 1, fontWeight: 700, fontSize: 10, color: '#1A5276' }}>Photo</span>
          <span style={{ width: 18, height: 18, borderRadius: '50%', background: '#16A34A', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 800 }}>2</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 6 }}>
          <div style={{ padding: '4px 6px', borderRadius: 6, border: '1px solid #D4680A', background: '#FFF8F0', textAlign: 'center' }}>
            <div style={{ fontSize: 14, fontWeight: 800, color: '#D4680A' }}>2</div><div style={{ fontSize: 7, fontWeight: 700, color: '#D4680A' }}>AMB</div>
          </div>
          <div style={{ padding: '4px 6px', borderRadius: 6, border: '1px solid #1A5276', background: '#F0F6FF', textAlign: 'center' }}>
            <div style={{ fontSize: 14, fontWeight: 800, color: '#1A5276' }}>1</div><div style={{ fontSize: 7, fontWeight: 700, color: '#1A5276' }}>FROID</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          <div style={{ flex: 1, padding: '6px', borderRadius: 6, background: '#16A34A', color: 'white', textAlign: 'center', fontSize: 10, fontWeight: 700 }}>Prête</div>
          <div style={{ padding: '6px 8px', borderRadius: 6, border: '1px solid #E8E8EE', textAlign: 'center', fontSize: 9, color: '#888' }}>Fiche</div>
          <div style={{ padding: '6px 8px', borderRadius: 6, border: '1px solid #FDECEA', background: '#FFF5F5', textAlign: 'center', fontSize: 9, color: '#C0392B' }}>Anomalie</div>
          <div style={{ padding: '6px 8px', borderRadius: 6, border: '1px solid #E8E8EE', textAlign: 'center', fontSize: 9, color: '#888' }}>Libérer</div>
        </div>
      </div>
    </div>
  );
}

function VisualEnCours() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ padding: '6px 8px', background: '#FFF8F0', borderRadius: 6, borderLeft: '2px solid #1A5276', marginBottom: 4 }}>
        <div style={{ display: 'inline-block', padding: '2px 6px', borderRadius: 4, background: '#D4680A', color: 'white', fontSize: 8, fontWeight: 700, marginBottom: 3 }}>🔧 En cours par Gaye</div>
        <div style={{ fontWeight: 600, fontSize: 10 }}>PHARMACIE DU CENTRE</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', padding: '6px 8px', background: 'white', borderRadius: 6, borderLeft: '2px solid #1A5276' }}>
        <span style={{ flex: 1, fontWeight: 500, fontSize: 10 }}>PHARMACIE DE LA GARE</span>
        <span style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #1A5276', color: '#1A5276', fontSize: 9, fontWeight: 700 }}>▶ Je prends</span>
      </div>
    </div>
  );
}

function VisualFiche() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6 }}>PHARMACIE DU CENTRE</div>
      <div style={{ background: 'white', borderRadius: 6, padding: '6px 8px', marginBottom: 3, border: '0.5px solid #E8E8EE' }}>
        <div style={{ fontSize: 10, fontWeight: 600, color: '#6B7280' }}>▶ Produits (5 réf.)</div>
      </div>
      {['① Caisses + 🔀 Transfert', '② Photos', '③ Anomalies'].map((s, i) => (
        <div key={i} style={{ background: 'white', borderRadius: 6, padding: '6px 8px', marginBottom: 3, border: '0.5px solid #E8E8EE' }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: i === 0 ? '#1A5276' : '#9CA3AF' }}>{s}</div>
        </div>
      ))}
    </div>
  );
}

function VisualCaisses() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
        <div style={{ flex: 1, padding: 4, background: 'white', borderRadius: 6, border: '1px solid #D4680A', textAlign: 'center' }}>
          <div style={{ fontSize: 14, fontWeight: 800, color: '#D4680A' }}>3</div><div style={{ fontSize: 7, fontWeight: 700, color: '#D4680A' }}>AMBIANT</div>
          <div style={{ fontSize: 7, color: '#999' }}>1 autre</div>
        </div>
        <div style={{ flex: 1, padding: 4, background: 'white', borderRadius: 6, border: '1px solid #1A5276', textAlign: 'center' }}>
          <div style={{ fontSize: 14, fontWeight: 800, color: '#1A5276' }}>1</div><div style={{ fontSize: 7, fontWeight: 700, color: '#1A5276' }}>FROID</div>
        </div>
      </div>
      <div style={{ padding: '4px 8px', borderRadius: 4, background: '#FEF3CD', border: '1px solid #F5CBA7', fontSize: 9, color: '#7D5A0A', fontWeight: 600 }}>
        Colis existants : 1 ambiant — par Alexandre
      </div>
    </div>
  );
}

function VisualCamera() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', textAlign: 'center' }}>
      <div style={{ padding: '8px 10px', borderRadius: 8, border: '1.5px dashed #1A5276', background: '#EEF6FF', display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center' }}>
        <span style={{ fontSize: 16 }}>📸</span>
        <span style={{ fontWeight: 700, fontSize: 11, color: '#1A5276' }}>Photo</span>
        <span style={{ width: 20, height: 20, borderRadius: '50%', background: '#16A34A', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 800 }}>3</span>
      </div>
      <div style={{ fontSize: 9, color: '#888', marginTop: 4 }}>1 tap = 1 photo · le compteur monte</div>
    </div>
  );
}

function VisualAnomalies() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      {['Produit manquant', 'Produit abîmé', 'Écart quantité'].map((a, i) => (
        <div key={i} style={{ display: 'inline-block', padding: '4px 10px', borderRadius: 6, margin: '0 4px 4px 0', border: '1px solid ' + (i === 0 ? '#1A5276' : '#E8E8EE'), background: i === 0 ? '#E6F1FB' : 'white', fontSize: 10, fontWeight: i === 0 ? 600 : 400, color: i === 0 ? '#1A5276' : '#6B7280' }}>{a}</div>
      ))}
    </div>
  );
}

function VisualPrete() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11, textAlign: 'center' }}>
      <div style={{ padding: '10px 16px', borderRadius: 10, background: '#16A34A', color: 'white', fontWeight: 700, fontSize: 13 }}>Prête</div>
      <div style={{ fontSize: 9, color: '#888', marginTop: 4 }}>La pharmacie passe dans les Départs</div>
    </div>
  );
}

function VisualDeparts() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ padding: '6px 10px', background: '#1A5276', borderRadius: 6, marginBottom: 6 }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: 'white' }}>📅 Départs — Lun 23 Mars</div>
        <div style={{ fontSize: 8, color: '#B3D4F0' }}>3 prêtes · 20 parties</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', padding: '5px 8px', background: '#F0FAF4', borderRadius: 4, marginBottom: 2, border: '1px solid #C3E6CB' }}>
        <span style={{ width: 14, height: 14, borderRadius: '50%', background: '#D5F5E3', color: '#1E6B3C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8 }}>✓</span>
        <span style={{ flex: 1, fontWeight: 500, fontSize: 9, marginLeft: 4 }}>PHARMACIE NANA</span>
        <span style={{ fontSize: 8, color: '#1E6B3C' }}>Partie</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', padding: '5px 8px', background: 'white', borderRadius: 4, border: '1px solid #E8E8EE' }}>
        <span style={{ width: 14, height: 14, borderRadius: '50%', background: '#E6F1FB', color: '#1A5276', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, fontWeight: 700 }}>2</span>
        <span style={{ flex: 1, fontWeight: 500, fontSize: 9, marginLeft: 4 }}>PHARMACIE DU 26</span>
        <div style={{ display: 'flex', gap: 2 }}>
          <span style={{ padding: '2px 4px', borderRadius: 3, background: '#18181A', color: 'white', fontSize: 7, fontWeight: 600 }}>🚚</span>
          <span style={{ padding: '2px 4px', borderRadius: 3, background: '#FFF8F0', color: '#D4680A', fontSize: 7, fontWeight: 600 }}>→ Demain</span>
        </div>
      </div>
    </div>
  );
}

function VisualTransporteurs() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      {['ETP', 'CIBLEX', 'Chronopost', 'DHL'].map((t, i) => (
        <div key={i} style={{ padding: '8px 10px', background: i === 0 ? '#E6F1FB' : 'white', borderRadius: 6, marginBottom: 3, border: i === 0 ? '2px solid #1A5276' : '1px solid #E8E8EE', fontWeight: i === 0 ? 700 : 400, fontSize: 11, color: i === 0 ? '#1A5276' : '#374151' }}>{t}</div>
      ))}
    </div>
  );
}

function VisualCompteurs() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      {[{ label: 'Colis ambiants', emoji: '📦', val: 11, bg: '#FFFBEB' }, { label: 'Colis froids', emoji: '❄️', val: 3, bg: '#EFF6FF' }, { label: 'Palettes', emoji: '🏗️', val: 0, bg: 'white' }].map((c, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 10px', background: c.val > 0 ? c.bg : 'white', borderRadius: 6, marginBottom: 3, border: '1px solid #E8E8EE' }}>
          <span>{c.emoji} {c.label}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ width: 20, height: 20, borderRadius: 4, border: '1px solid #D1D5DB', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, background: 'white' }}>−</span>
            <span style={{ fontWeight: 800, fontSize: 14, minWidth: 24, textAlign: 'center' }}>{c.val}</span>
            <span style={{ width: 20, height: 20, borderRadius: 4, border: '1px solid #D1D5DB', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, background: 'white' }}>+</span>
          </div>
        </div>
      ))}
    </div>
  );
}

function VisualOkAnomalie() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', display: 'flex', gap: 6 }}>
      <div style={{ flex: 1, padding: '10px 6px', borderRadius: 8, border: '2px solid #16A34A', background: '#D5F5E3', textAlign: 'center' }}>
        <div style={{ fontSize: 18 }}>✓</div>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#16A34A' }}>Tout OK</div>
      </div>
      <div style={{ flex: 1, padding: '10px 6px', borderRadius: 8, border: '2px solid #C0392B', background: '#FDECEA', textAlign: 'center' }}>
        <div style={{ fontSize: 18 }}>!</div>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#C0392B' }}>Anomalie</div>
      </div>
    </div>
  );
}

function VisualSearchP() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ padding: '8px 10px', borderRadius: 6, border: '1px solid #E8E8EE', background: 'white', fontFamily: 'monospace', fontSize: 14, fontWeight: 700, marginBottom: 6 }}>P307</div>
      {['P30704 — PFIZER non EDI', 'P30722 — COOPER PHARMA'].map((r, i) => (
        <div key={i} style={{ padding: '6px 8px', borderRadius: 6, background: 'white', borderLeft: '3px solid #1A5276', marginBottom: 3, fontSize: 10 }}>
          <div style={{ fontWeight: 700, fontFamily: 'monospace' }}>{r.split(' — ')[0]}</div>
          <div style={{ color: '#6B7280' }}>{r.split(' — ')[1]}</div>
        </div>
      ))}
    </div>
  );
}

function VisualBadgesABCV() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 10 }}>
      <div style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
        <span style={{ padding: '2px 6px', borderRadius: 4, background: '#FEF3CD', color: '#D4680A', fontSize: 9, fontWeight: 700, border: '1px solid #F0C36D' }}>1 ABCV</span>
        <span style={{ padding: '2px 6px', borderRadius: 4, background: '#F3F4F6', color: '#6B7280', fontSize: 9, fontWeight: 600 }}>1 stock normal</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 8px', background: 'white', borderRadius: 6, marginBottom: 3, border: '0.5px solid #E8E8EE' }}>
        <span style={{ width: 18, height: 18, borderRadius: '50%', background: '#FEF3CD', color: '#D4680A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, fontWeight: 700 }}>1</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 9, fontWeight: 500 }}>VYNDAQEL 61 mg (tafamidis)</div>
          <span style={{ padding: '1px 4px', borderRadius: 3, background: '#FEF3CD', color: '#D4680A', fontSize: 8, fontWeight: 700, border: '1px solid #F0C36D' }}>ABCV · 20 en ABCV</span>
        </div>
        <span style={{ fontWeight: 700, color: '#1A5276', fontSize: 12 }}>40</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 8px', background: 'white', borderRadius: 6, border: '0.5px solid #E8E8EE' }}>
        <span style={{ width: 18, height: 18, borderRadius: '50%', background: '#F3F4F6', color: '#6B7280', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, fontWeight: 700 }}>2</span>
        <div style={{ flex: 1, fontSize: 9, fontWeight: 500 }}>NIMENRIX, vaccin méningococci...</div>
        <span style={{ fontWeight: 700, color: '#1A5276', fontSize: 12 }}>9</span>
      </div>
    </div>
  );
}

function VisualABCVCalc() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 10 }}>
      <div style={{ background: 'white', borderRadius: 6, borderLeft: '3px solid #D4680A', padding: 8, marginBottom: 6 }}>
        <div style={{ fontWeight: 600, fontSize: 10, marginBottom: 4 }}>VYNDAQEL 61 mg</div>
        <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
          <div style={{ flex: 1 }}><div style={{ fontSize: 8, color: '#6B7280' }}>Qté reçue</div><div style={{ fontSize: 14, fontWeight: 700, textAlign: 'center' }}>40</div></div>
          <div style={{ flex: 1 }}><div style={{ fontSize: 8, color: '#6B7280' }}>DLU courte ?</div><div style={{ display: 'flex', gap: 2 }}><span style={{ flex: 1, padding: '3px', borderRadius: 4, border: '1px solid #16A34A', background: '#D5F5E3', textAlign: 'center', fontSize: 9, fontWeight: 700, color: '#16A34A' }}>NON</span><span style={{ flex: 1, padding: '3px', borderRadius: 4, border: '1px solid #E8E8EE', textAlign: 'center', fontSize: 9, color: '#9CA3AF' }}>OUI</span></div></div>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          <div style={{ flex: 1, padding: 4, borderRadius: 4, background: '#FEF3CD', textAlign: 'center', border: '1px solid #F0C36D' }}><div style={{ fontSize: 14, fontWeight: 700, color: '#D4680A' }}>20</div><div style={{ fontSize: 7, fontWeight: 600, color: '#D4680A' }}>EN ABCV</div></div>
          <div style={{ flex: 1, padding: 4, borderRadius: 4, background: '#F9FAFB', textAlign: 'center', border: '1px solid #E8E8EE' }}><div style={{ fontSize: 14, fontWeight: 700, color: '#1A5276' }}>20</div><div style={{ fontSize: 7, fontWeight: 600, color: '#9CA3AF' }}>STOCK NORMAL</div></div>
        </div>
      </div>
    </div>
  );
}

function VisualPhotosBL() {
  return (
    <div style={{ padding: 12, background: '#F2F3F7', fontSize: 11 }}>
      <div style={{ fontSize: 10, fontWeight: 600, color: '#16A34A', marginBottom: 4 }}>✓ Photo BL (1)</div>
      <div style={{ padding: '8px 10px', borderRadius: 6, border: '1.5px dashed #1A5276', background: '#F0F7FF', textAlign: 'center', marginBottom: 6 }}>
        <div style={{ fontSize: 16 }}>📷</div>
        <div style={{ fontSize: 10, fontWeight: 600, color: '#1A5276' }}>Prendre des photos du BL</div>
      </div>
      <div style={{ fontSize: 10, fontWeight: 600, color: '#C0392B', marginBottom: 4 }}>● Photos produits (0)</div>
      <div style={{ padding: '8px 10px', borderRadius: 6, border: '1.5px dashed #1A5276', background: '#F0F7FF', textAlign: 'center' }}>
        <div style={{ fontSize: 16 }}>📷</div>
        <div style={{ fontSize: 10, fontWeight: 600, color: '#1A5276' }}>Prendre des photos des produits</div>
      </div>
    </div>
  );
}


// ═══════════════════════════════════════
// TUTORIAL CONTENT
// ═══════════════════════════════════════

export const TUTO_GLOBAL = [
  {
    icon: '👋', title: 'Bienvenue sur Elixir Prep',
    text: 'Cette app gère les préparations pharmacies, les départs, les réceptions et les anomalies. Tout est tracé : qui a préparé quoi, quand, combien de colis. Ça remplace Asana et OrcaScan.',
    tip: '⚠️ Si tu remarques un bug ou si tu as une suggestion, fais-en part à Zineb. Tu peux relancer ce guide avec le bouton 📖.',
  },
  {
    icon: '🏠', title: 'Ton accueil',
    text: 'Deux onglets principaux : Préparations et Départs. Préparations = ce qu\'il faut emballer. Départs = ce qui est prêt à partir. Tu ne vois que les modules auxquels tu as accès.',
    tip: 'Tire la page vers le bas pour actualiser les données.',
    visual: <VisualHub />,
  },
  {
    icon: '⚡', title: 'Le flux rapide',
    text: 'Le flux normal : "Je prends" → photo → caisses → "Prête". Tout se fait depuis le panneau rapide en bas de l\'écran, sans ouvrir la fiche. Tu ne peux prendre qu\'une pharmacie à la fois.',
    tip: 'Pour les cas complexes (anomalie, transfert colis, détail produits) → tape "Fiche" ou "Anomalie" dans le panneau.',
  },
];

export const TUTO_PREP = [
  {
    icon: '📋', title: 'Les préparations',
    text: 'Ici tu vois toutes les pharmacies à préparer, classées par tournée. Les tournées terminées se replient toute seules — tu vois toujours celle sur laquelle tu dois travailler en premier.',
    tip: 'Les pharmacies à préparer sont en haut, celles en cours au milieu, les prêtes en bas.',
    visual: <VisualTournees />,
  },
  {
    icon: '📅', title: 'Quand est-ce que ça part ?',
    text: 'Chaque pharmacie a un badge "📅 Départ Lun 23" qui te dit quand elle sera livrée. Si une pharmacie commande vendredi à 17h → elle part lundi. Si elle commande lundi à 10h → elle part mardi.',
    tip: 'L\'heure de chaque commande est affichée à côté du numéro (ex: S131044 20/03 17:24).',
    visual: <VisualClaim />,
  },
  {
    icon: '▶', title: '"Je prends" — le raccourci',
    text: 'Tape "▶ Je prends" directement sur la carte. Un panneau s\'ouvre en bas avec tout ce qu\'il faut : photo, caisses, cartons. Tu n\'as pas besoin d\'ouvrir la fiche pour les cas simples.',
    tip: 'Tu ne peux prendre qu\'une seule pharmacie à la fois. Finis-la avant d\'en prendre une autre.',
    visual: <VisualQuickPanel />,
  },
  {
    icon: '📸', title: 'Prendre des photos',
    text: 'Dans le panneau rapide, tape le bouton 📸. La caméra s\'ouvre. Prends une photo par étage (étiquette + produits). Le compteur monte à chaque photo. Si tu oublies, l\'app te demandera confirmation.',
    visual: <VisualCamera />,
  },
  {
    icon: '📦', title: 'Les caisses et cartons',
    text: 'Avec les boutons +/- tu déclares : caisses ambiantes, froides, cartons standard, cartons vrac. Chaque colis est enregistré à ton nom. Si un autre magasinier a déjà mis des colis, tu les vois mais tu ne peux pas les retirer.',
    tip: 'Si un colis est mal attribué → ouvre la fiche → "🔀 Détail colis & transfert" pour le déplacer vers une autre pharmacie.',
    visual: <VisualCaisses />,
  },
  {
    icon: '✅', title: 'Marquer "Prête"',
    text: 'Quand les photos et colis sont faits, tape "Prête". Le panneau se ferme, la pharmacie passe en vert et apparaît dans les Départs. Tu peux immédiatement taper "Je prends" sur la suivante.',
    visual: <VisualPrete />,
  },
  {
    icon: '⚠️', title: 'Signaler une anomalie',
    text: 'Si un produit manque ou est abîmé, tape "Anomalie" dans le panneau rapide. Ça t\'envoie directement dans la fiche pharmacie sur la section Anomalies. Choisis le type, ajoute un commentaire si besoin.',
    visual: <VisualAnomalies />,
  },
  {
    icon: '🔓', title: 'Libérer une pharmacie',
    text: 'Si tu t\'es trompé ou si tu dois partir, tape "Libérer" dans le panneau rapide. La pharmacie redevient disponible pour les autres. Tes photos et colis sont gardés.',
  },
  {
    icon: '💊', title: 'La fiche complète',
    text: 'Pour les cas complexes (voir les produits, transférer un colis, historique), tape "Fiche" dans le panneau rapide. Tu y trouves tout le détail : produits, caisses avec transfert 🔀, photos, anomalies.',
    visual: <VisualFiche />,
  },
  {
    icon: '🔧', title: 'Qui prépare quoi',
    text: 'Quand quelqu\'un prend une pharmacie, un badge orange indique son nom. Comme ça tout le monde sait ce qui est pris et ce qui reste à faire. En haut de la page, tu vois "Ma préparation" — ta pharmacie en cours.',
    visual: <VisualEnCours />,
  },
  {
    icon: '🚚', title: 'Les Départs',
    text: 'L\'onglet Départs montre les pharmacies prêtes à partir, groupées par jour de livraison. Le responsable peut : valider le départ, imprimer le bon, reporter à demain, ou réordonner les pharmacies de la tournée.',
    tip: 'L\'ordre des pharmacies dans les Départs = l\'ordre du bon de transport. Il est sauvegardé et réutilisé chaque jour.',
    visual: <VisualDeparts />,
  },
];

export const TUTO_RECEPTION_T = [
  {
    icon: '🚛', title: 'Réception transporteurs',
    text: 'Quand un camion arrive à l\'entrepôt, ouvre cette section pour enregistrer la livraison.',
  },
  {
    icon: '🚛', title: 'Le transporteur',
    text: 'Tape sur le nom du transporteur (ETP, CIBLEX, Chronopost...). Si c\'est un autre, tape "Autre transporteur" et saisis le nom.',
    visual: <VisualTransporteurs />,
  },
  {
    icon: '📦', title: 'Colis et palettes',
    text: 'Indique le nombre de colis ambiants, froids, et palettes. Tu peux taper directement le chiffre ou utiliser les boutons +/-.',
    visual: <VisualCompteurs />,
  },
  {
    icon: '✅', title: 'État de la livraison',
    text: 'Tout est OK ? Tape "Aucune anomalie". Sinon tape "Anomalie" et sélectionne le(s) type(s) : colis manquant, cartons abîmés, etc.',
    visual: <VisualOkAnomalie />,
  },
  {
    icon: '📷', title: 'Photos + Valider',
    text: 'Prends des photos du BL tamponné et des colis. Puis valide. La réception est enregistrée et envoyée automatiquement.',
  },
];

export const TUTO_RECEPTION_P = [
  {
    icon: '📦', title: 'Réception produits',
    text: 'Quand tu ouvres un colis de laboratoire, ouvre cette section pour enregistrer ce que tu as reçu.',
  },
  {
    icon: '🔍', title: 'La référence P...',
    text: 'Tape "P" suivi d\'au moins 2 chiffres (ex: P30) et les résultats apparaissent automatiquement. Sélectionne la commande pour voir les produits attendus. Si tu n\'as pas le numéro, tape "Créer une réception manuellement".',
    visual: <VisualSearchP />,
  },
  {
    icon: '🟠', title: 'Produits ABCV et Permanent',
    text: 'L\'app te montre directement où ranger chaque produit. Badge orange ABCV → zone ABCV, avec la quantité à mettre (ex: reçu 40 et ABCV 20 → 20 en ABCV + 20 en stock normal). Badge bleu PERMANENT → emplacement dédié. Pas de badge → stock normal.',
    visual: <VisualBadgesABCV />,
  },
  {
    icon: '🔍', title: 'Tout est conforme ?',
    text: 'Vérifie chaque produit visuellement : CIP, lot, date, quantité, état des boîtes. Un rappel s\'affiche. Si tout est OK → tape "Tout OK". Si problème → tape "Anomalie" et sélectionne le(s) produit(s).',
    visual: <VisualOkAnomalie />,
  },
  {
    icon: '🟠', title: 'Quantités ABCV',
    text: 'Si la commande contient des produits ABCV, l\'app te demande la quantité reçue et si la date est courte (< 12 mois). Elle calcule automatiquement ce qui va en ABCV et ce qui va en stock normal.',
    visual: <VisualABCVCalc />,
  },
  {
    icon: '📷', title: 'Photos + Terminer',
    text: 'Prends des photos du BL et des produits (obligatoire). Tape "Terminer la réception". C\'est enregistré.',
    visual: <VisualPhotosBL />,
  },
];
